import React from 'react'
import CircularProgress from 'material-ui/CircularProgress'

const Spinner = ({ centered = false }) => (
  <div
    className={centered ? 'text-center' : ''}
    style={{ marginTop: '20px', marginBottom: '20px' }}>
    <CircularProgress size={60} thickness={5} />
  </div>
)

export default Spinner



// WEBPACK FOOTER //
// ./src/common/Spinner.js